<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useMessageContext } from '../provider.js';
import BaseAttachmentBubble from './BaseAttachment.vue';

const { contentAttributes } = useMessageContext();

const { t } = useI18n();

const paymentData = computed(() => contentAttributes.value?.data || {});

const title = computed(() => {
  const { number, currency, amount_cents: amountCents } = paymentData.value;
  const amount = `${currency} ${((amountCents || 0) / 100).toFixed(2)}`;
  return number ? `${number} · ${amount}` : amount;
});

const providerLabel = computed(() => {
  const provider = paymentData.value.provider || '';
  return provider.charAt(0).toUpperCase() + provider.slice(1);
});

const action = computed(() => ({
  label: t('INVOICES.BUBBLE.OPEN_LINK'),
  href: paymentData.value.payment_url,
}));
</script>

<template>
  <BaseAttachmentBubble
    icon="i-ph-receipt-fill"
    icon-bg-color="bg-[#5C2D91]"
    sender-translation-key="CONVERSATION.SHARED_ATTACHMENT.PAYMENT"
    :title="title"
    :content="$t('INVOICES.BUBBLE.PAY_WITH', { provider: providerLabel })"
    :action="action"
  />
</template>
